import Landing2Banner from "./Landing2Banner";
import {Header} from "../Header/Header";
import Footer from "../Footer/Footer";
import Landing2Go from "./Landing2Go";
import Landing2Market from "./Landing2Market";
import Landing2Get from "./Landing2Get";
import Landing2Apps from "./Landing2Apps";
import Landing2Choose from "./Landing2Choose";
import Landing2Works from "./Landing2Works";
import ShuttleAppreciation from "../shuttle_software/ShuttleAppreciation";
import TaxiFaq from "../taxiDispatchSoftware/TaxiFaq";
import Landing2Launch from "./Landing2Launch";
import { Helmet } from "react-helmet-async";

const faqData = [
  {
    id: "0",
    question: "01. What is taxi dispatch software, and how does it work?",
    answer:
      "Taxi dispatch software is a technology solution that helps taxi companies manage their operations more  efficiently. It automates the process of dispatching rides to drivers, tracking vehicle locations, and managing customer bookings. By using a taxi dispatch system, businesses can streamline their operations, improve response times, and enhance customer satisfaction.",
  },
  {
    id: "1",
    question: "02. How can taxi management software benefit my business?",
    answer:
      "Taxi management software provides a comprehensive solution for handling various aspects of a taxi business, including ride bookings, driver management, and fare calculations. With a Taxi Software Solution, you can improve operational efficiency, reduce errors, and gain valuable insights through data analytics. This leads to better decision-making and ultimately drives business growth.",
  },
  {
    id: "2",
    question: "03. Is your taxi dispatch system UK compliant?",
    answer:
      "Yes, our taxi dispatch system is designed to meet the specific regulations and requirements of the UK market. We ensure that our taxi management software adheres to local laws and standards, providing you with a reliable solution for managing your taxi operations while remaining compliant.",
  },
  {
    id: "3",
    question: "04. Can I integrate ride-sharing management software with my existing systems?",
    answer:
      "Absolutely! Our ride-sharing management software is built to be flexible and easily integrated with your current systems. This allows you to enhance your existing operations without starting from scratch. Whether you use a taxi dispatch system or other software solutions, our taxi management software can seamlessly connect to create a unified platform for your business.",
  },
  {
    id: "4",
    question: "05. What features should I look for in cab software?",
    answer:
      "When choosing cab software, consider features such as real-time GPS tracking, automated dispatching, payment processing, customer management, and reporting tools. Our pre-built taxi dispatch software includes all these essential features and more, providing a comprehensive solution to effectively manage your taxi business.",
  },
];
export default function LandingTwo() {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header/>
      <Landing2Banner />
      <Landing2Go/>
      <Landing2Market/>
      <Landing2Get/>
      <Landing2Apps/>
      <Landing2Choose/>
      <Landing2Works/>
      <section className="land2-testimonial"><ShuttleAppreciation/></section>
      <section className="land2-faq"><TaxiFaq faqData={faqData}/></section>
      <Landing2Launch/>
      <Footer/>
    </>
  )
}
